// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#detail-accounts-payable-card[data-v-48b576ec]  .card.open .card-header{border-bottom:1px solid #ebe9f1}", ""]);
// Exports
module.exports = exports;
